import "./HotelRevenueManagementInNainital.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Landscape from "./sections/Landscape";
import RevenueGrid from "./sections/RevenueGrid";
import Comparison from "./sections/Comparison";
import Integrations from "./sections/Integrations";
import Faq from "./sections/Faq";
import RevparInquiry from "./sections/RevparInquiry";
import Footer from "@/reusable_sections/Footer";
export default function HotelRevenueManagementInNainitalPage() {
  return <div>
      <Header />
      <Hero />
      <Landscape />
      <RevenueGrid />
      <Comparison />
      <Integrations />
      <Faq />
      <RevparInquiry />
      <Footer />
    </div>;
}